module.exports = __webpack_public_path__ + "static/media/insights_logo.85cf1f19.png";